export const getCanvasFixedSize = (mode?: string, property?: string, value?: string | number): string => {
    if (mode === 'auto') {
      return 'auto';
    } else if (mode === 'min-content') {
      return 'min-content';
    } else if (mode === 'max-content') {
      return 'max-content';
    } else if (mode === '%' || mode === 'px') {
      return `${value ?? ''}${mode}`;
    } else {
        return property === "width" ? '100%' : "auto";
    }
  };
  